export default __webpack_public_path__ + "static/filmkino-6a1433957b8bb4dbb7480e2761756cf3.png";